import React, { useState } from 'react';
import {
  Box,
  Button,
  Heading,
  Input,
  Stack,
  Flex,
  Text,
  VStack,
  Container
} from '@chakra-ui/react';
import { HiChartSquareBar } from 'react-icons/hi';
import { toaster } from "./ui/toaster.jsx";
import { Field } from './ui/field.jsx';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('username', username);
      formData.append('password', password);

      const response = await axios.post('/token', formData);
      localStorage.setItem('token', response.data.access_token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
      onLoginSuccess();
      navigate('/');
    } catch (error) {
      toaster.create({
        title: '登录失败',
        description: error.response?.data?.detail || error.message,
        type: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="bg.canvas"
      p={4}
    >
      <Container maxW="sm">
        <VStack gap={8} w="full" align="stretch">
          <VStack gap={4} align="center" textAlign="center">
            <Box
              p={3}
              bg="brand.500"
              color="white"
              borderRadius="lg"
              display="inline-flex"
            >
              <HiChartSquareBar size={24} />
            </Box>
            <VStack gap={1}>
              <Heading size="2xl" fontWeight="bold" letterSpacing="tight">
                RichCalls
              </Heading>
              <Text color="text.muted" fontSize="md">
                专业交易系统
              </Text>
            </VStack>
          </VStack>

          <Box
            as="form"
            onSubmit={handleSubmit}
            bg="bg.surface"
            p={8}
            borderRadius="xl"
            border="1px solid"
            borderColor="border.subtle"
            boxShadow="sm"
          >
            <Stack gap={6}>
              <VStack align="flex-start" gap={2}>
                  <Heading size="md">欢迎回来</Heading>
                  <Text color="text.muted" fontSize="sm">请输入账号密码登录</Text>
              </VStack>

              <Stack gap={4}>
                <Field label="用户名">
                  <Input
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    size="lg"
                    placeholder="输入用户名"
                  />
                </Field>

                <Field label="密码">
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    size="lg"
                    placeholder="••••••••"
                  />
                </Field>
              </Stack>

              <Button
                type="submit"
                loading={isLoading}
                size="lg"
                w="full"
                colorPalette="blue"
                variant="solid"
              >
                登录
              </Button>
            </Stack>
          </Box>

          <Text align="center" color="text.muted" fontSize="xs">
            © 2026 RichCalls Trading System
          </Text>
        </VStack>
      </Container>
    </Flex>
  );
};

export default Login;
